import { toast } from 'react-toastify';
import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from "../../utils/clientAuth.js";

const getMobileNoInfoService = (actionCallback, mobileNo) => {
    let token = "Token " + localStorage.getItem('token')
let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
  let traceId = getClientId();   
fetch( plink + s.mobno_info + "/" + mobileNo, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-Client-APP':buildClientHeader(),
        })
    })
        .then(res => {

            if (res.status === 200) {
                if (localStorage.getItem('mobileNoToast') === 'first') {
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('mobileNoToast', 'second')
                }
                res.json().then(json => actionCallback(json, "success"))
            }
            else if(res.status === 401){
                actionCallback("401", "sessionout")
            }
            else if (res.status === 500) {
                if (localStorage.getItem('mobileNoToast') === 'first') {
                    toast.error('Invalid Mobile Number', {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                // localStorage.setItem('mobileNoToast', 'second')
            }
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getMobileNoInfoService;


// WEBPACK FOOTER //
// ./src/services/components/mobileno_info.jsx